import { DEFAULT_DOWN_PAYMENT_PERCENT } from '@atc/wallet-payment-fns';

export const initWalletManager = ({ useStaging, downPaymentPercent, tenant, featureToggles, drSettings }) => {
	const hasDrSettings = drSettings && Object.keys(drSettings).length > 0;
	// eslint-disable-next-line
	window.walletManager = new walletManager({
		environment: useStaging ? 'staging' : 'prod',
		walletDefaults: {
			downPaymentPercent: downPaymentPercent || DEFAULT_DOWN_PAYMENT_PERCENT,
			tenant: tenant || '',
		},
		featureToggles: featureToggles || {},
		...(hasDrSettings && { drSettings }),
	});
}
